import { css } from '@emotion/react';
import { DownloadSimple } from '@phosphor-icons/react';
import { useEditAppContext } from 'client/lib/EditApp';
import { useDeploymentClientState } from 'client/state/DeploymentClientState';
import { EditAppSaveButton } from 'client/components/EditApp/EditAppSaveButton';
import { Settings, Section, SectionSkeleton } from 'client/components/Layout/Settings';
import { ComponentsSections } from '../../sections/components/ComponentsSections';
import { SettingsActions } from './components/SettingsActions';
import { SettingsGeneral } from './components/SettingsGeneral';
import { SettingsHosts } from './components/SettingsHosts';
import { SettingsSize } from './components/SettingsSize';

export const DeploymentOptionsTab = () => {
  const editAppContext = useEditAppContext();
  const isHostsVisible = useDeploymentClientState((state) =>
    (state.document?.componentsWithValues || []).some((component) => component.hosts.length > 0)
  );
  const isReady = editAppContext.isReady;

  return (
    <Settings css={settingsStyle}>
      {!isReady && <SectionSkeleton />}

      {isReady && (
        <>
          <Section title="General" subtitle="Basic information about this deployment.">
            <SettingsGeneral />
          </Section>

          <Section title="Size" subtitle="Configure the computing resources for this deployment.">
            <SettingsSize />
          </Section>

          {isHostsVisible && (
            <Section title="Endpoints" subtitle="Configure endpoints used to connect to different services running in this deployment.">
              <SettingsHosts />
            </Section>
          )}

          <ComponentsSections />

          {/* <Section title="Environment" subtitle="Edit environment variables.">
            <SettingsEnvironment />
          </Section> */}

          <Section title="Actions" subtitle="Run one-time actions for this deployment." css={actionsStyle}>
            <SettingsActions />
          </Section>

          <Section css={footerStyle}>
            {/* <Banner css={{ marginTop: '2rem' }}>
              Some items are hidden due to the deployment type being <b>development</b>.<br />
              <a>Show hidden items.</a>
            </Banner>

            <Banner type="warning" css={{ marginTop: '2rem' }}>
              TODO: Changes should be visible here in a nice Git diff style report.
            </Banner> */}

            <EditAppSaveButton icon={<DownloadSimple weight="regular" />} primary large>
              Save Changes
            </EditAppSaveButton>
          </Section>
        </>
      )}
    </Settings>
  );
};

const settingsStyle = css`
  margin-top: -4rem;
`;

const actionsStyle = css`
  align-items: center;
`;

const footerStyle = css`
  > div {
    display: flex;
    align-items: center;
    justify-content: right;
  }
`;
